// packages import
import { Box, Button, List, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { forwardRef, useContext, useImperativeHandle, useRef } from "react";
// other
import { AppContext } from "../../context";
import { ActionType } from "../../context/AppContextReducer";
import { ListBoxProps, NullableUlElement } from "../../interfaceTypes";
import { ListBoxStyles, autocompletePaperStyles } from "../../theme/styleConstants";

const ListBox = forwardRef<HTMLUListElement, Omit<ListBoxProps, "ref">>(function ListBoxBase(props, ref) {
  const { children, ...rest } = props;
  const innerRef = useRef<HTMLUListElement>(null)
  const { isEdit, dispatch } = useContext(AppContext)
  const handModelNewClient = () => dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
  useImperativeHandle<NullableUlElement, NullableUlElement>(ref, () => innerRef.current);

  return (
    <List {...rest} ref={innerRef} role="list-box" sx={ListBoxStyles}>
      {children}

      <Box onMouseDown={event => event.preventDefault()} sx={autocompletePaperStyles}>
        <Typography color='darkRed'>
          Didn’t find any judge?
        </Typography>

        <Button
          variant="text"
          color='primary'
          sx={{ background: grey[300] }}
          onClick={handModelNewClient}
          aria-label='add new'
        >
          + Add NEW
        </Button>
      </Box>
    </List>
  );
});

export default ListBox;